import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCompilationThumbnail, postCompilationRating } from "../apis/music-api";
import { AuthenticationContext } from "../authentication/AuthenticationContext";
import { FileResponse } from "../../types/FileResponse";
import { BeatLoader } from "react-spinners";
import { Box, Rating, Stack, Typography, useMediaQuery } from "@mui/material";
import { Compilation } from "../../types/Compilation";
import callApi from "../call-api/call-api";
import { trackDuration } from "../text-helper/text-helper";

type CompilationProps = {
    directory: string,
    compilation: Compilation,
}

const GridCompilation = (props: CompilationProps) => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ thumbnail, setThumbnail ] = useState<FileResponse>();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [rating, setRating] = useState<number | null>(props.compilation.rating ?? 0);

    useEffect(() => {
        if (props.compilation.title !== undefined && props.compilation.year > 0) {
            callApi<FileResponse>(getCompilationThumbnail(getAccessToken(), props.directory, `${props.compilation.year} - ${props.compilation.title}`), setThumbnail);
        }
    }, [props.directory, props.compilation.year, props.compilation.title, getAccessToken]);

    const handleRatingChange = (newValue: number | null) => {
        if (newValue === null) {
            return;
        }

        setRating(newValue);
        callApi<boolean>(postCompilationRating(getAccessToken(), props.directory, `${props.compilation.year} - ${props.compilation.title}`, newValue.toString()), () => {});
    }

    return (
        <Stack direction={isSmall ? "column" : "row"}>
            <Box
                alignItems={'center'}
                justifyContent={'center'}
                sx={{
                    width: '120px',
                    height: '120px'
                }}
            >
                {thumbnail?.fileContents !== undefined &&
                    <Link to={`/compilations/${props.directory}/albums/${props.compilation.year} - ${props.compilation.title}`}>
                        <img alt={props.compilation.title} width={'120px'} height={'120px'} src={`data:image/jpeg;base64,${thumbnail?.fileContents}`} />
                    </Link>
            }
                <BeatLoader
                    loading={thumbnail?.fileContents === undefined}
                    size={24}
                    aria-label="Loading Spinner"
                    data-testid="loader" />
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    textAlign: 'left',
                    paddingLeft: isSmall ? '0px' : '12px',
                }}
            >
                <div><b>{props.compilation.year}</b></div>
                <div>
                    <Link
                        style={{ color: 'inherit' }}
                        to={`/compilations/${props.directory}/albums/${props.compilation.year} - ${props.compilation.title}`}
                    >
                        {props.compilation.title}
                    </Link>
                </div>
                <div>
                    <Rating name="compilation-rating" value={rating} precision={1.0} onChange={(event, newValue) => handleRatingChange(newValue)} />
                </div>
            </Box>
            <Box
                sx={{
                    width: '120px',
                    textAlign: isSmall ? 'left' : 'right'
                }}
            >
                <Typography variant="body1">{props.compilation.trackCount} tracks</Typography>
                <Typography variant="body1">({trackDuration(props.compilation.totalDuration)})</Typography>
            </Box>
        </Stack>
    );
}

export default GridCompilation;